import React, { useEffect, useState } from 'react';
import { useAtom } from 'jotai';
import { sessionAtom } from '../../../jotai/atoms/session';
import { CurrentQuestion } from './Question/CurrentQuestion';
import { QuestionList } from './Question/QuestionList';
import { ContentPanel } from '../../UI/ContentPanel';
import { SidePanel } from '../../UI/SidePanel';
const Quiz = ({ code, questions, duration, onSubmit }) => {
    const [session, setSession] = useAtom(sessionAtom);
    const [currentQuestion, setCurrentQuestion] = useState({
        questionIndex: 0,
        questionId: '',
        text: '',
        optionA: '',
        optionB: '',
        optionC: '',
        optionD: '',
        selected: undefined,
    });
    useEffect(() => {
        setSession((session) => ({
            ...session,
            questions: questions,
            duration: Number(duration),
        }));
        setCurrentQuestion({ ...questions[0], questionIndex: 0 });
    }, []);
    const handleQuestionSelect = (i) => {
        const question = session.questions.find((_question, index) => index === i);
        setCurrentQuestion({ ...question, questionIndex: i });
    };
    const handleQuestionPrevious = () => {
        const newIndex = currentQuestion.questionIndex - 1;
        const question = session.questions.find((_question, index) => index === newIndex);
        setCurrentQuestion({
            ...question,
            questionIndex: newIndex,
        });
    };
    const handleQuestionNext = () => {
        const newIndex = currentQuestion.questionIndex + 1;
        const question = session.questions.find((_question, index) => index === newIndex);
        setCurrentQuestion({
            ...question,
            questionIndex: newIndex,
        });
    };
    const handleOptionSelect = (e) => {
        const target = e.target;
        if (target.id === currentQuestion.selected) {
            setSession((session) => ({
                ...session,
                questions: session.questions.map((question) => question.questionId === currentQuestion.questionId
                    ? { ...question, selected: undefined }
                    : question),
            }));
            setCurrentQuestion({ ...currentQuestion, selected: undefined });
        }
        else {
            setSession((session) => ({
                ...session,
                questions: session.questions.map((question) => question.questionId === currentQuestion.questionId
                    ? { ...question, selected: target.id }
                    : question),
            }));
            setCurrentQuestion({
                ...currentQuestion,
                selected: target.id,
            });
        }
    };
    const handleSubmitQuiz = () => {
        onSubmit(code, {
            fullName: session.user.name,
            email: session.user.email,
            attemptedQuestions: session.questions
                .filter((question) => question.selected)
                .map((question) => ({
                questionId: question.questionId,
                selected: question.selected,
            })),
        });
        setSession((session) => ({
            ...session,
            submitted: true,
            duration: 0,
        }));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(ContentPanel, { component: CurrentQuestion, props: {
                totalQuestions: session.questions.length,
                question: currentQuestion,
                onOptionSelect: handleOptionSelect,
                onPrevious: handleQuestionPrevious,
                onNext: handleQuestionNext,
            } }),
        React.createElement(SidePanel, { component: QuestionList, props: {
                currentQuestionId: currentQuestion.questionId,
                questions: session.questions,
                onQuestionSelect: handleQuestionSelect,
                onSubmit: handleSubmitQuiz,
            } })));
};
export { Quiz };
